import React from "react";
import {useSearchParams} from "react-router-dom";
import {SEARCH_PARAMS} from "components/Layout/constants";
import {useDispatch} from "react-redux";
import {setCurrentSearchParams} from "store/actions/assetLibrary";
import styles from "./index.module.scss";

function AssetListLayout({title, type, assetSearchParams, children}) {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const handleClickMore = () => {
    searchParams.set(SEARCH_PARAMS.TYPE, type);
    setSearchParams(searchParams);
    dispatch(setCurrentSearchParams(assetSearchParams));
  };

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h3 className={styles.title}>{title}</h3>
        <button>
          <p className={styles.more} onClick={handleClickMore}>
            See All
          </p>
        </button>
      </header>

      {children}
    </div>
  );
}

export default AssetListLayout;
